import { Link } from "react-router-dom";
import { PenTool, Package, Search, Bot, ArrowRight } from "lucide-react";

const actions = [
  {
    label: "Write a Script",
    description: "Generate viral-ready video scripts with AI",
    href: "/app/nexis-ai",
    icon: <PenTool className="w-5 h-5" />,
    gradient: "from-primary to-purple-600",
  },
  {
    label: "Build a Product",
    description: "Turn your niche expertise into a sellable product",
    href: "/app/monetization-ai",
    icon: <Package className="w-5 h-5" />,
    gradient: "from-green-500 to-emerald-600",
  },
  {
    label: "Find Keywords",
    description: "Discover high-opportunity topics in your niche",
    href: "/app/keyword-research",
    icon: <Search className="w-5 h-5" />,
    gradient: "from-amber-500 to-orange-600",
  },
  {
    label: "Ask for Help",
    description: "Get personalised guidance from your AI mentor",
    href: "/app/askfint",
    icon: <Bot className="w-5 h-5" />,
    gradient: "from-blue-500 to-cyan-600",
  },
];

export function QuickActions() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {actions.map((action) => (
        <Link
          key={action.href}
          to={action.href}
          className="glass-card p-4 hover:border-primary/30 transition-all group"
        >
          <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${action.gradient} flex items-center justify-center mb-3 text-white`}>
            {action.icon}
          </div>
          <h3 className="font-semibold text-sm text-foreground group-hover:text-primary transition-colors mb-1">
            {action.label}
          </h3>
          <p className="text-xs text-muted-foreground leading-relaxed">{action.description}</p>
          <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary mt-2 transition-colors" />
        </Link>
      ))}
    </div>
  );
}
